import { useState } from 'react';
import { useApi } from './useApi';
import { getRolePrivilegesRequest } from '../api/rolesApi';
import { useUserStore } from '../store';
import { useAdminRole } from './useAdminRole';

const privilegesByRoleId = new Map();

const mapPrivilegeCodes = (items) => items.map((item) => item?.privilege_attributes?.attributes?.code);

const getRolePrivilegesCached = (roleId) => {
  const cached = privilegesByRoleId.get(roleId);
  if (cached?.codes) return cached.raw;
  if (cached?.promise) return cached.promise;

  const promise = getRolePrivilegesRequest(roleId, { total: 10000 })
    .then((raw) => {
      privilegesByRoleId.set(roleId, { raw, codes: mapPrivilegeCodes(raw) });
      return raw;
    })
    .catch((error) => {
      privilegesByRoleId.delete(roleId);
      throw error;
    });

  privilegesByRoleId.set(roleId, { promise });
  return promise;
};

export function usePrivilegeRole() {
  const { userStore } = useUserStore();
  const roleId = userStore?.role_id;
  const [privileges, setPrivileges] = useState(() => privilegesByRoleId.get(roleId)?.codes);

  const { isUserMainAdmin } = useAdminRole();

  useApi({
    setter: (newPrivileges) => {
      const codes = mapPrivilegeCodes(newPrivileges);
      privilegesByRoleId.set(roleId, { raw: newPrivileges, codes });
      setPrivileges(codes);
    },
    shouldRequest: roleId,
    request: () => getRolePrivilegesCached(roleId),
  });

  const checkPrivilege = (comparePrivilege) => Boolean(privileges?.includes?.(comparePrivilege));

  const checkIsSuperAdmin = () => true;

  return isUserMainAdmin ? checkIsSuperAdmin : checkPrivilege;
}
